import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "directions"
const DirectionsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M5.935 3 3.31 5.625 5.935 8.25H10.125V3zM11.625 15H18.02L20.78 11.625 18.02 8.25H11.625zM11.625 6.75H18.022L18.19 6.76C18.577 6.803 18.932 6.997 19.18 7.3L21.943 10.675C22.394 11.228 22.394 12.022 21.942 12.575L19.18 15.95C18.897 16.298 18.47 16.5 18.02 16.5H11.625V21.75C11.625 22.164 11.289 22.5 10.875 22.5S10.125 22.164 10.125 21.75V9.75H5.935C5.538 9.75 5.156 9.592 4.875 9.31L2.25 6.687C1.664 6.1 1.664 5.15 2.25 4.564L4.875 1.94C5.156 1.66 5.538 1.5 5.935 1.5H10.125C10.953 1.5 11.625 2.171 11.625 3z" />
        </svg>
      }
    </span>
  )
}
export default DirectionsIcon
